import axios, { AxiosResponse } from 'axios';
import { ShopperEventDto, EventType, CashRewardInfo, PhysicalRewardInfo, RewardType } from '@luckycart/xpn-types';

import { Logger } from '../utils/Logger';

interface SendRewardInfoFilledEventParams {
  siteKey: string;
  shopperId: string;
  experienceId: string;
  rewardInfo: CashRewardInfo | PhysicalRewardInfo;
  rewardType: RewardType;
  operationId: string;
  sequenceId?: string;
  journeyId?: string;
}

export class EventService {

  private readonly hostShopperEvent: string;

  public constructor () {
    this.hostShopperEvent = process.env.REACT_APP_SHOPPER_EVENT_BASE_URL as string;
  }

  /**
   * send an event to save cash reward data
   * @param {string} siteKey
   * @param {string} shopperId
   * @param {string} experienceId
   * @param {CashRewardInfo} rewardData
   * @returns {Promise<void>}
   */
  public sendRewardInfoFilledEvent ({
    siteKey,
    shopperId,
    experienceId,
    rewardInfo,
    rewardType,
    sequenceId,
    journeyId,
  }: SendRewardInfoFilledEventParams): Promise<boolean> {
    const event: ShopperEventDto = {
      eventName: EventType.REWARD_INFO_FILLED,
      shopperId,
      siteKey,
      payload: {
        type: rewardType,
        experienceId,
        rewardInfo,
        sequenceId,
        journeyId,
      },
    };

    return this.sendEvent(event);
  }

  /**
   * Send an event to XPN
   * @param {Record<string, unknown>} event
   * @returns {Promise<void>}
   */
  private async sendEvent (event: ShopperEventDto): Promise<boolean> {
    const eventUrl = `${this.hostShopperEvent}/v1/event`;
    const response = await axios.post<ShopperEventDto, AxiosResponse>(eventUrl, event);
    if (response.data.err !== undefined) {
      Logger.error(`Couldn't send the XPN event ${event.eventName}`, response.data.err);
    }

    return response.status === 201;
  }
}

export const eventServiceInstance = new EventService();
